import { inject, Inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { extractErrorMessage } from '../utils/utils';

export interface ReportData {
  headers: string[],
  data: any[]
}

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  baseUrl: string = environment.api_url;
  httpClient: HttpClient = inject(HttpClient);

  generateReport(dataType: string, reportData: ReportData): Observable<Blob> {
    const params = new HttpParams().set('report-type', dataType);

    return this.httpClient.post<Blob>(`${this.baseUrl}/reports`, reportData, { params, responseType: 'blob' as 'json' }).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }
}
